import React from 'react';
import ScoreCountHourly from '../../common/ScoreCountHourly';

const RatingRow = ({dayData, data}) => {

    // Backend omits rating_score entirely when the spot has no rating preferences set.
    if(!data.rating_score){
        return <></>
    }

    return (
        <tr className="hover:bg-custom-darker/50 transition-colors">
            <td className="pl-2 pb-1 pt-2 text-xs text-custom-light-grey ">
                <div className="inline-flex items-center gap-1 font-medium flex-wrap">
                    <span className="block sm:hidden">Rating</span>
                    <span className="hidden sm:inline-block">Star Rating</span>
                </div>
            </td>
            {dayData.map(({ index }) => (
                <td key={index} className="pl-2 pb-1 pt-2 text-center">
                    <div className="inline-flex flex-col items-center gap-1">
                        <ScoreCountHourly score={data.rating_score[index]} />
                    </div>
                </td>
            ))}
        </tr>
    )
}

export default RatingRow;
